export default __webpack_public_path__ + "media/images/invite-user-6567bb42adfbdcc4f1fa0c5064f0537d.png";